import { Loader2 } from 'lucide-react';
import styles from '../styles/AIAssistant.module.css';
import { Group, Text } from '../ui/primitives.js';

export function AIAssistantThinkingIndicator() {
  return (
    <div className={styles.thinkingContainer} data-testid="ai-thinking-indicator">
      <Group gap="xs" align="center">
        <Loader2 size={16} className={styles.thinkingSpinner} />
        <Text size="xs" className={styles.thinkingText}>
          Thinking...
        </Text>
      </Group>
    </div>
  );
}
